/**
 * MenuButton Component
 *
 * Individual menu button with hover states
 */

import styles from './MenuButton.module.css';

function MenuButton({ onClick, isActive, children }) {
    const buttonClass = isActive ? `${styles.button} ${styles.active}` : styles.button;

    return (
        <button
            onClick={onClick}
            className={buttonClass}
        >
            {children}
        </button>
    );
}

export default MenuButton;
